import React, { Component } from 'react';
import { useNavigate,Redirect } from 'react-router-dom'

export class Login extends Component {

  constructor(props) {
    super(props);
    this.state = { email:"", loading: true,password:"",redirect:false };
  }

  setEmail = (val) => {
    this.setState({ email:val });
}

setPassword = (val) => {
  this.setState({ password: val });
}

setSession(val){
  window.localStorage.setItem("2k",val.session);
  var object = {value:val.session, timestamp: new Date().getTime()}
  localStorage.setItem("2k", JSON.stringify(object));
}

onButtonClick = async () => {

  const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: this.state.email,
        password: this.state.password
    })
  };

  

      const response = await fetch('login',requestOptions);
      const data = await response.json();

      
      if(data.session){
        this.setSession(data);
        this.setState({redirect:true});
      }
      else{
        console.log("edit failed");
      }
     
     

  }

render() {
  return (
      <div>
          <div className={'mainContainer'}>
      <div className={'titleContainer'}>
        <div>Login</div>
      </div>
      <br />
      <div className={'inputContainer'}>
        <input
          value={this.state.email}
          
          onChange={(ev) => this.setEmail(ev.target.value)}
          className={'form-control'}
        />
       
      </div>
      <br />
      <div className={'inputContainer'}>
        <input
          type="password"
          value={this.state.password}
          onChange={(ev) => this.setPassword(ev.target.value)}
          className={'form-control'}
        />
      </div>
      <br />
      <div className={'inputContainer'}>
        <input className={'form-control'} type="button" onClick={this.onButtonClick} value={'Log in'} />
      </div>
    </div>
    { this.state.redirect ?  <Redirect to='/'  />: null }
      </div>
  );
}
}